import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../api';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [tab,  setTab]  = useState('customer');
  const [form, setForm] = useState({ email:'', password:'' });
  const [err,  setErr]  = useState('');
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const handle = async e => {
    e.preventDefault(); setErr(''); setBusy(true);
    try {
      const fn = tab==='customer' ? authAPI.customerLogin : tab==='provider' ? authAPI.providerLogin : authAPI.adminLogin;
      const r = await fn(form);
      login(r.data.user, r.data.role, { access: r.data.access, refresh: r.data.refresh });
      nav(r.data.role==='provider' ? '/provider/dashboard' : r.data.role==='admin' ? '/admin' : '/dashboard');
    } catch(e) { setErr(e.response?.data?.error || 'Login failed'); }
    setBusy(false);
  };

  const upd = k => e => setForm(f=>({...f,[k]:e.target.value}));

  return (
    <div className="page-container" style={{maxWidth:460,paddingTop:60}}>
      <div className="section-title" style={{marginBottom:4}}>Sign In</div>
      <div className="section-sub" style={{marginBottom:28}}>Access your iTekPros account</div>

      <div style={{display:'flex',gap:4,marginBottom:24,background:'rgba(255,255,255,0.03)',padding:4,borderRadius:8}}>
        {[['customer','Customer'],['provider','Provider'],['admin','Admin']].map(([v,l])=>(
          <button key={v} onClick={()=>{setTab(v);setErr('');}}
            style={{flex:1,padding:'8px',borderRadius:6,fontSize:13,fontWeight:500,border:'none',
              background:tab===v?'rgba(0,194,255,0.15)':'transparent',
              color:tab===v?'#1E7FD4':'#8899AA',transition:'all 0.2s',cursor:'pointer'}}>
            {l}
          </button>
        ))}
      </div>

      {err && <div className="alert alert-error">{err}</div>}

      <form onSubmit={handle}>
        <div className="form-group">
          <label className="form-label">Email</label>
          <input type="email" value={form.email} onChange={upd('email')} placeholder="you@email.com" required />
        </div>
        <div className="form-group">
          <label className="form-label">Password</label>
          <input type="password" value={form.password} onChange={upd('password')} placeholder="••••••••" required />
        </div>
        <button type="submit" className="btn btn-primary" style={{width:'100%',marginTop:4}} disabled={busy}>
          {busy ? <><span className="spinner"/>  Signing in...</> : 'Sign In →'}
        </button>
      </form>

      <div style={{textAlign:'center',marginTop:20,fontSize:13,color:'#556677'}}>
        {tab==='customer' && <>No account? <Link to="/register">Create one</Link></>}
        {tab==='provider' && <>Want to join? <Link to="/join">Apply as a pro</Link></>}
      </div>
    </div>
  );
}
